import React, { Component } from "react";

import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Button,
  Label,
  Input,
  Container,
  // CustomInput,
  // InputGroup,
  // Form,
  // InputGroupAddon,
} from "reactstrap";
import { connect } from "react-redux";

// import { AvForm, AvField, AvInput } from "availity-reactstrap-validation";
// import avatar2 from "../../assets/images/users/avatar-2.jpg";
import { ChangePasswordSubmit } from "../../store/UserProfile/actions";
import { Link } from "react-router-dom";

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      OldPassword: "",
      NewPassword: "",
      ConfirmPassword: "",
      error: false,
      oldPasswordError: false,
      ChangePasswordBtn: true,
    };
  }
  handleOldPasswordChange(e) {
    this.setState({
      OldPassword: e.target.value,
    });
  }
  handlePasswordChange(e) {
    if (this.state.ConfirmPassword !== e.target.value) {
      this.setState({
        error: true,
        ChangePasswordBtn: true,
      });
    } else {
      this.setState({
        ChangePasswordBtn: false,
        error: false,
      });
    }
    this.setState({
      NewPassword: e.target.value,
    });
  }
  handleConfirmPassword(e) {
    this.setState({
      ConfirmPassword: e.target.value,
    });
    if (this.state.NewPassword !== e.target.value) {
      this.setState({
        error: true,
        ChangePasswordBtn: true,
      });
    } else {
      this.setState({
        ChangePasswordBtn: false,
        error: false,
      });
    }
  }
  OnSubmit() {
    if (this.state.OldPassword !== "") {
      this.setState({
        oldPasswordError: false,
      });
      if (this.state.NewPassword !== "") {
        var data = {
          old_password: this.state.OldPassword,
          password: this.state.NewPassword,
        };

        this.props.ChangePasswordSubmit(data, this.props.history);
      }
    } else {
      this.setState({
        oldPasswordError: true,
      });
    }
  }
  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Card>
              <CardHeader className="bg-transparent border-bottom">
                <h3 className="card-title-18 pt-2">Password and Login</h3>
              </CardHeader>
              <CardBody>
                <Row className="justify-content-center">
                  <Col xs={9}>
                    <Card>
                      <CardBody>
                        <h4 className="card-title-18">Change Password</h4>

                        <Row className="justify-content-center">
                          <Col xs={9}>
                            <FormGroup row>
                              <Col md={4}>
                                <Label
                                  htmlFor="Current-password-input"
                                  className="col-form-label float-right"
                                >
                                  Current Password
                                </Label>
                              </Col>
                              <Col md={8}>
                                <Input
                                  className="form-control"
                                  type="password"
                                  name="oldPassword"
                                  id="Current-password-input"
                                  onChange={(e) => {
                                    this.handleOldPasswordChange(e);
                                  }}
                                />
                                {this.state.oldPasswordError && (
                                  <span className=" text-danger">
                                    Password is Required!
                                  </span>
                                )}
                                {this.props.apiError?.old_password && (
                                  <span className=" text-danger">
                                    {
                                      this.props.apiError?.old_password
                                        ?.old_password
                                    }
                                  </span>
                                )}
                              </Col>
                            </FormGroup>
                            <FormGroup row>
                              <Col md={4}>
                                <Label
                                  htmlFor="new-password-input"
                                  className="col-form-label float-right"
                                >
                                  New Password
                                </Label>
                              </Col>
                              <Col md={8}>
                                <Input
                                  className="form-control"
                                  type="password"
                                  name="Newpassword"
                                  id="New-password-input"
                                  onChange={(e) => {
                                    this.handlePasswordChange(e);
                                  }}
                                />
                                {this.props.apiError?.password && (
                                  <span className=" text-danger">
                                    {this.props.apiError?.password[0]}
                                  </span>
                                )}
                              </Col>
                            </FormGroup>
                            <FormGroup row>
                              <Col md={4}>
                                <Label
                                  htmlFor="confirm-password-input"
                                  className="col-form-label float-right"
                                >
                                  Confirm Password
                                </Label>
                              </Col>
                              <Col md={8}>
                                <Input
                                  className="form-control"
                                  type="password"
                                  name="confimPassword"
                                  id="confirm-password-input"
                                  onChange={(e) => {
                                    this.handleConfirmPassword(e);
                                  }}
                                />
                                {this.state.error && (
                                  <span className=" text-danger">
                                    Passwords don't match
                                  </span>
                                )}
                              </Col>
                            </FormGroup>

                            <div className="float-right">
                              <Button
                                type="submit"
                                color="primary"
                                className="mr-2"
                                disabled={this.state.ChangePasswordBtn}
                                onClick={() => {
                                  this.OnSubmit();
                                }}
                              >
                                Change password
                              </Button>
                              <Link to="/dashboard">
                                <Button type="submit" color="light">
                                  Cancel
                                </Button>
                              </Link>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
const mapStatetProps = (state) => {
  const { apiError } = state.userProfile;

  return { apiError };
};
export default connect(mapStatetProps, {
  ChangePasswordSubmit,
})(ChangePassword);
